import React from 'react';
import type { NotificationLogs as NotificationLogsType } from '@atlassian/jira-spa-apps-servicedesk-notification-logs/src/ui/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyNotificationLogs = lazyForPaint<typeof NotificationLogsType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-notification-logs", jiraSpaEntry: "async-servicedesk-notification-logs" */ '@atlassian/jira-spa-apps-servicedesk-notification-logs'
		),
	),
);

export const NotificationLogs = () => (
	<LazyPage
		Page={LazyNotificationLogs}
		pageId="spa-apps/servicedesk/notification-logs"
		shouldShowSpinner
	/>
);
